import { useContext } from 'react';
import { SDKContext } from './context';

export const useNBCUSDK = () => {
  const context = useContext(SDKContext);
  if (!context) {
    throw new Error('useNBCUSDK must be used within an SDKProvider');
  }
  return context;
};
